'use strict';

require('./ReportByItemTransaction.scss');


const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    moment = require('moment'),
    ContentUtils = require('utils/ContentUtils'),
    DateUtils = require('utils/DateUtils'),
    InventoryStore = require('stores/InventoryStore'),
    {DatePicker, CircularProgress} = require('material-ui'),
    {cloneDeep} = require('lodash/lang'),
    get = require('lodash/object').get,
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    TextFieldSuggested = require('components/Commons/TextField/TextFieldSuggested/TextFieldSuggested');

const ReportByItemTransaction = React.createClass({displayName: "ReportByItemTransaction",

    getInitialState() {
        return {
            filter: {
                moduleName: 'REPORT_BY_ITEM_TRANSACTION',
                messageErrorItem: '',
                dateTo: new Date(),
                dateFrom: moment().add(-1, 'days').toDate(),
                reportKey: '',
                isFetching: true,
                isGeneratingReport: false
            }
        };
    },

    componentDidMount() {
        this.fetchItems();
    },

    fetchItems() {
        this.setState({
            isFetching: true
        }, () => {
            InventoryStore.fetchAllItems((items) => {
                const itemsSorted = ContentUtils.sortList(items, 'description');
                this.setState({
                    items: ContentUtils.filterEnable(itemsSorted),
                    isFetching: false
                });
            });
        });
    },

    onChangeFrom(nil, dateFrom) {
        this.setState(prevState => {
            prevState.filter.dateFrom = dateFrom;
            return prevState;
        });
    },

    onChangeTo(nil, dateTo) {
        this.setState(prevState => {
            prevState.filter.dateTo = dateTo;
            return prevState;
        });
    },

    _onSubmit() {
        let filter = cloneDeep(this.state.filter);
        filter.dateFrom = this.refs.dateFrom.getDate().toISOString();
        filter.dateTo = this.refs.dateTo.getDate().toISOString();
        filter.itemId = get(this.state, 'itemSelected.id');

        if (!filter.itemId) {
            this.setState({
                messageErrorItem: t('report_item_warning_item_is_required')
            });
            return;
        }

        filter.reportKey = 'REPORT_BY_ITEM_TRANSACTION';
        
        this.setState({
            isGeneratingReport: true
        }, () => {
            InventoryStore.downloadReportXLS(filter, 'items/by-item-transaction', () => {
                this.setState({
                    isGeneratingReport: false,
                    messageErrorItem: ''
                });
            }, () => {
                this.setState({
                    messageErrorItem: t('dashboard_notification_something_was_wrong')
                });
            });
        });
    },


    onItemSelected(itemSelected) {
        const textWritten = get(itemSelected, this.props.readerAttribute);
        this.setState({
            itemSelected,
            textWritten
        });
    },

    render() {
        const {dateFrom, dateTo} = this.state.filter;
        const {items, itemSelected, messageErrorItem, isFetching, isGeneratingReport} = this.state;

        return (
            React.createElement("div", {className: "report-by-beer-style"}, 
                React.createElement("div", {className: "report-by-beer-style__header"}, t('report_by_item_transaction')), 
                React.createElement("div", {className: "report-by-beer-style__body"}, 
                    React.createElement("div", {className: "report-by-beer-style__body-row"}, 
                        React.createElement("label", {style: {marginBottom: '8px'}, 
                               className: "report-by-beer-style__body-row-title"}, t('report_beer_style_range')), 
                        React.createElement(DatePicker, {
                            formatDate: DateUtils.toDateText, 
                            ref: "dateFrom", 
                            style: {maxWidth: '200px', overflow: 'auto'}, 
                            value: dateFrom, 
                            onChange: this.onChangeFrom, 
                            floatingLabelText: t('report_beer_style_from')}
                        ), 
                        React.createElement(DatePicker, {
                            formatDate: DateUtils.toDateText, 
                            ref: "dateTo", 
                            value: dateTo, 
                            style: {maxWidth: '200px', overflow: 'auto'}, 
                            onChange: this.onChangeTo, 
                            floatingLabelText: t('report_beer_style_to')}
                        )
                    ), 
                    React.createElement("div", {className: "report-by-beer-style__body-row"}, 
                        React.createElement("label", {style: {marginBottom: 0}, className: "report-by-beer-style__body-row-title-show-by"}, t('report_by_item_transaction_label_item_description')), 
                        React.createElement(TextFieldSuggested, {
                            readerAttribute: "description", 
                            items: items, 
                            readerAttributeValue: "id", 
                            className: "report-by-item-transaction", 
                            floatingLabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                            LabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                            value: itemSelected, 
                            floatingLabelText: t('report_item_description'), 
                            style: {width: '100%', color: 'white !important', fontWeight: '300'}, 
                            onItemSelected: this.onItemSelected, 
                            errorText: messageErrorItem
                        }
                        ), 
                        isFetching && React.createElement(CircularProgress, null)
                    ), 
                    React.createElement("div", {className: "report-by-beer-style__submit"}, 
                        React.createElement(FormGroupButton, {
                            className: "primary-icon", 
                            type: "icon", 
                            label: t('report_item_download_report'), 
                            onClick: isGeneratingReport ? () => {} : this._onSubmit, 
                            disable: isGeneratingReport}
                        ), 
                        isGeneratingReport && React.createElement(CircularProgress, {size: .4})
                    )
                )
            )
        );
    }
});

module.exports = ReportByItemTransaction;



/** WEBPACK FOOTER **
 ** ./src/views/ReportAdmin/ReportByItemTransaction/ReportByItemTransaction.jsx
 **/